var version = '0.6.6';
export { version };
//# sourceMappingURL=version.js.map